import { createObjectUrl } from '../../files';
import { uuid } from '../../id/utils/uuid/uuid';

import { Bale, NewEvidence } from '../types';

export const createBaleFromFile = (photo: File): Bale => ({
  id: uuid(),
  photo: photo,
});

export const createNewEvidence = (photo: File): NewEvidence => ({
  file: photo,
  id: uuid(),
  photo: createObjectUrl(photo),
  variant: 'new',
});
